import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AddressDetails } from '../../models/address.types';
import { UiFormFieldComponent } from '../ui-form-field/ui-form-field.component';

@Component({
  selector: 'ui-address-form',
  standalone: true,
  imports: [UiFormFieldComponent],
  templateUrl: './ui-address-form.component.html',
  styleUrl: './ui-address-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiAddressFormComponent {
  readonly value = input.required<AddressDetails>();
  readonly valueChange = output<AddressDetails>();

  setValue(key: keyof AddressDetails, rawValue: string): void {
    if (key === 'geo') {
      return;
    }

    this.valueChange.emit({ ...this.value(), [key]: rawValue });
  }

  setGeo(index: 0 | 1, rawValue: string): void {
    const parsed = Number(rawValue);
    const geo: [number, number] = [...this.value().geo] as [number, number];
    geo[index] = Number.isFinite(parsed) ? parsed : 0;
    this.valueChange.emit({ ...this.value(), geo });
  }
}
